export const CATALOG_URL = '/catalog'
